// extracted by mini-css-extract-plugin
export default {"information":"Instruction_information__1PPVE","header":"Instruction_header__NQwM6","instruction":"Instruction_instruction__-PyJ8"};